import React from "react";
import { Link } from "react-router-dom";
import { Translate } from "react-redux-i18n";

export function renderPanelTabLabel(text, count) {
  return (
    <span className="panel-tab-label">
      {text}
      <span className="panel-tab-count">{count}</span>
    </span>
  );
}

export default function PanelAdsHeader({ title, newTo, onNewClick, subtitle }) {
  return (
    <header className="panel-ads-page__header">
      <div>
        <h1 className="panel-ads-page__title">{title}</h1>
        {subtitle != null && subtitle !== "" && (
          <p className="panel-ads-page__subtitle">{subtitle}</p>
        )}
      </div>
      {onNewClick ? (
        <button
          type="button"
          className="panel-ads-page__new-btn"
          onClick={onNewClick}
        >
          <Translate value="new" />
        </button>
      ) : (
        newTo && (
          <Link className="panel-ads-page__new-btn" to={newTo}>
            <Translate value="new" />
          </Link>
        )
      )}
    </header>
  );
}
